import { useRef, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import AddLeaveModal from "../../components/UI/AddLeaveModal";
import DeleteButton from "../../components/UI/AlertDialog";
import Notification from "../../components/UI/Notification";
import axios from "axios";
import { getToken } from "../../../src/utils/tokenUtils";
import Drawer from "../../components/UI/Drawer";
import ReactPaginate from 'react-paginate';
import { X } from "lucide-react"; 
import { getRoleBasedRoute } from "../../utils/routeUtils";
import { AuthContext } from "../../contexts/AuthContext";
import { createPortal } from 'react-dom';
import { MoreVertical, AlertTriangle } from 'lucide-react';
import DropdownMenu from "../../components/UI/DropdownMenu";


const LeavePage = () => {
    const { user } = useContext(AuthContext)
    const [requests, setRequests] = useState([]);
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedLeave, setSelectedLeave] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [notification, setNotification] = useState(null);
    const [filter, setFilter] = useState("All");
    const [formData, setFormData] = useState({
        // leave_period: "",
        from_date: "",
        to_date: "",
        start_day: "",
        start_half: "",
        last_day: "",
        last_half: "",
        leave_type: "",
        total_days: "",
        reason: "",
    });
    const token = getToken();
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        perPage: 15,
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [leaveLoading, setLeaveLoading] = useState(false);
    const [error, setError] = useState("");
    const [total_days, setTotalDays] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [isFiltering, setIsFiltering] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [activeFilters, setActiveFilters] = useState({});
    const [filteredData, setFilteredData] = useState(requests);
    const [tempFilters, setTempFilters] = useState({});
    const { roles } = useContext(AuthContext);
    const [dropdownRow, setDropdownRow] = useState(null);
    const [openRow, setOpenRow] = useState(null);
    const buttonRef = useRef(null);

    const getRoleBasedRouteLocal = (route) => {
        return getRoleBasedRoute(route, roles);
    };

    // console.log("this is active filters: ", activeFilters)

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFilterChange = (field, value) => {
        setActiveFilters(prev => ({
        ...prev,
        [field]: value
        }));
        // setShowFilterMenu(false); 
    };

    const clearFilters = () => {
        setActiveFilters({});
        setSearchQuery("");
    };

    const clearFilterByKey = (key) => {
        const updatedFilters = { ...activeFilters };
        delete updatedFilters[key];
        setActiveFilters(updatedFilters);
    };

    // Define the filterable columns based on your table structure
    const filterableColumns = [
        { field: "from_date", label: "From Date" },
        { field: "to_date", label: "To Date" },
        { field: "leave_type", label: "Leave Type" },
        { field: "total_days", label: "Total Days" },
        { field: "status", label: "Status" },
    ];

    useEffect(() => {
    if (showFilterMenu) {
        setTempFilters(activeFilters);
    }
    }, [showFilterMenu]);

    useEffect(() => {
        setFilteredData(requests);
    }, [requests]);

    useEffect(() => {
        // Apply both search query and filters
        const normalizedRequests = requests.map(req => ({
            ...req,
            status: req.request?.status || ""
        }));

        let result = normalizedRequests;
        // let result = requests;

        // Apply search query filtering
        if (searchQuery) {
        const lowercasedQuery = searchQuery.toLowerCase();
        result = result.filter((item) => {
            // Search across all relevant fields
            return (
            (item.leave_type?.toString().toLowerCase().includes(lowercasedQuery)) ||
            (item.from_date?.toLowerCase().includes(lowercasedQuery)) ||
            (item.to_date?.toLowerCase().includes(lowercasedQuery)) ||
            (item.total_days?.toString().toLowerCase().includes(lowercasedQuery)) ||
            (item.status?.toLowerCase().includes(lowercasedQuery))
            );
        });
        }

        // Apply column-specific filters
        Object.entries(activeFilters).forEach(([field, filterValue]) => {
        if (filterValue) {
            result = result.filter(item => {
            const value = item[field];
            if (field === 'created_at' && value) {
                // Date filtering
                const itemDate = new Date(value);
                const day = String(itemDate.getDate()).padStart(2, '0');
                const month = String(itemDate.getMonth() + 1).padStart(2, '0');
                const year = itemDate.getFullYear();
                const formattedDate = `${day}-${month}-${year}`;
                
                return formattedDate.includes(filterValue);
            } else {
                // Standard string filtering
                return value?.toString().toLowerCase().includes(filterValue.toLowerCase());
            }
            });
        }
        });

        const filteringNow = searchQuery.length > 0 || Object.values(activeFilters).some(v => !!v);
        setIsFiltering(filteringNow);
        setFilteredData(result);
    }, [searchQuery, activeFilters, requests]);
    
    // console.log("Selected leave: ", selectedLeave)
    // working with half day count
    useEffect(() => {
        if (formData.from_date && formData.to_date) {
            const start = new Date(formData.from_date);
            const end = new Date(formData.to_date);
    
            if (start > end) {
                setTotalDays(0);
                setFormData((prev) => ({ ...prev, total_days: 0 }));
            } else {
                let daysDiff = (end - start) / (1000 * 60 * 60 * 24) + 1;
    
                // Subtract 0.5 for half day selections
                if (formData.start_day === "Half") {
                    daysDiff -= 0.5;
                }
                if (formData.last_day === "Half" && formData.from_date !== formData.to_date) {
                    daysDiff -= 0.5;
                }
    
                // Ensure not negative
                const finalDays = daysDiff < 0 ? 0 : daysDiff;
    
                setTotalDays(finalDays);
                setFormData((prev) => ({ ...prev, total_days: finalDays }));
            }
        } else {
            setTotalDays(0);
            setFormData((prev) => ({ ...prev, total_days: 0 }));
        }
    }, [formData.from_date, formData.to_date, formData.start_day, formData.last_day]);
    

    useEffect(() => {
        // console.log("Updated selectedLeave:", selectedLeave);
    }, [selectedLeave]);

    // fetch leave types
    const fetchLeaveTypes = async () => {
        try {
            const response = await axios.get("https://hrmsnew.prepstripe.com/api/masters/leave-types", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`, // Ensure token is available
                },
            });

            setLeaveTypes(response.data?.data || []); // Extract leave types from API response
            // Set the first leave type as default both in UI and formData
            if (leaveTypes.length > 0) {
                setFormData((prevData) => ({
                    ...prevData,
                    leave_type: prevData.leave_type || leaveTypes[0].name,
                }));
            }
        } catch (error) {
            // console.error("Error fetching leave types:", error);
            setNotification({
                message: `Error fetching leave types:", ${error}`,
                type: "error"
            });
        }
    };

    // fetched leave requests
    const fetchLeaveRequests = async (page = 1) => {
        try {
            setLeaveLoading(true)
            const response = await axios.get(
                `https://hrmsnew.prepstripe.com/api/leave-requests?page=${page}`,
                {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                }
            );
            setLeaveLoading(false)
            const data = response.data; // Ensure correct data structure
            setRequests(Array.isArray(data?.data) ? data.data : Array.isArray(data?.data?.data) ? data.data.data : []);
        
            setPagination({
                currentPage: data?.current_page || 1,
                totalPages: data?.last_page || 1,
                totalItems: data?.total || 0,
                perPage: data?.per_page || 10,
            });
      
        } catch (error) {
          setLeaveLoading(false)
        //   console.error("Error fetching leave requests:", error);
          setNotification({
            message: `Error fetching leave types:", ${error}`,
            type: "error"
        });
        }
    };
      
    // Fetch shift change requests from API
    useEffect(() => {
        fetchLeaveRequests();
        fetchLeaveTypes();
    }, [token]);

    // working
    const handleChange = (e) => {
        const { name, value } = e.target;
        // console.log(`Updating ${name} to: `, value); // Debugging
    
        setFormData((prev) => {
            let updatedData = {
                ...prev,
                [name]: value,
                ...(name === "start_day" && value === "Full" ? { start_half: "" } : {}),
                ...(name === "last_day" && value === "Full" ? { last_half: "" } : {}),
            };
    
            // If start_day is changed to "Half", default start_half to "First" unless user selects "Select an option"
            if (name === "start_day") {
                updatedData.start_half = value === "Half" ? "First" : "";
            }
    
            // If last_day is changed to "Half", default last_half to "First" unless user selects "Select an option"
            if (name === "last_day") {
                updatedData.last_half = value === "Half" ? "First" : "";
            }
    
            // Clear last_day and last_half if from_date and to_date are the same
            if (updatedData.from_date === updatedData.to_date) {
                updatedData.last_day = "";
                updatedData.last_half = "";
            }

            // Ensure to_date is not before from_date
            if (name === "from_date" && prev.to_date && prev.to_date < value) {
                updatedData.to_date = ""; // clear invalid to_date
            }

            if (name === "to_date" && prev.from_date && value < prev.from_date) {
                alert("To Date cannot be earlier than From Date.");
                return prev; // don't update state
            }
    
            return updatedData;
        });
    };
    
    const handleChangeEdit = (e) => {
        const { name, value } = e.target;
        // console.log(`Updating ${name} to: `, value); // Debugging
    
        setSelectedLeave((prev) => {
            if (!prev) return { [name]: value }; // Handle null case safely
    
            let updatedData = {
                ...prev,
                [name]: value,
                ...(name === "start_day" && value === "Full" ? { start_half: "" } : {}),
                ...(name === "last_day" && value === "Full" ? { last_half: "" } : {}),
            };
    
            // Clear last_day and last_half if from_date and to_date are the same
            if (updatedData.from_date === updatedData.to_date) {
                updatedData.last_day = "";
                updatedData.last_half = "";
            }

            // Ensure to_date is not before from_date
            if (name === "from_date" && prev.to_date && prev.to_date < value) {
                updatedData.to_date = ""; // clear invalid to_date
            }

            if (name === "to_date" && prev.from_date && value < prev.from_date) {
                alert("To Date cannot be earlier than From Date.");
                return prev; // don't update state
            }
    
            return updatedData;
        });
    };
    
    // Apply Leave
    const handleApplyLeave = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setNotification("");
    
        // console.log("formData, we about to submit: ", formData);

        if (!formData.reason.trim()) {
            // setNotification("Reason is required and cannot be empty or just spaces.");
            setNotification({
                message: "Reason is required and cannot be empty or just spaces.",
                type: "error"
            })
            setLoading(false);
            return; 
        }
    
        try {
            const response = await axios.post(
                "https://hrmsnew.prepstripe.com/api/leave-requests",
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );
    
            // setRequests([...requests, { ...response.data }]);
            setRequests([{ ...response.data}, ...requests]); // prepending data - new data first
            // setNotification("Leave applied successfully");
            setNotification({
                message: "Leave applied successfully",
                type: "success"
            });
    
            // Close modal and reset form
            setIsApplyModalOpen(false);
            resetForm();
        // } catch (err) {
        //     resetForm()
        //     // Check if there is a response from the API
        //     if (err.response) {
        //         setNotification({
        //             message: `${err.response.data.error || "Failed to apply for leave."}`,
        //             type: "error"
        //         });
        //     } else {
        //         // setNotification("Failed to apply for leave. Please try again.");
        //         setNotification({
        //             message: "Failed to apply for leave. Please try again.",
        //             type: "error"
        //         });
        //     }
        // } finally {
        //     setLoading(false);
        // }
        // } catch (err) {
        //     resetForm();

        //     if (err.response) {
        //         // Check if error object exists in response
        //         const apiError = err.response.data?.error;

        //         setNotification({
        //             message: apiError?.message || apiError || "Failed to apply for leave.",
        //             type: "error",
        //         });
        //     } else {
        //         setNotification({
        //             message: "Failed to apply for leave. Please try again.",
        //             type: "error",
        //         });
        //     }
        // } finally {
        //     setLoading(false);
        // }
        } catch (err) {
            resetForm();

            if (err.response) {
                const data = err.response.data;

                // Case 1: error object present (like LEAVE_DETAIL_MISSING)
                const apiErrorMessage = data?.error?.message;

                // Case 2: top-level message present (like Approvers not mapped)
                const topLevelMessage = data?.message;

                // Case 3: errors object with field-specific messages
                const fieldErrors = data?.errors
                    ? Object.values(data.errors).flat().join(" ")
                    : null;

                const finalMessage =
                    apiErrorMessage || topLevelMessage || fieldErrors || "Failed to apply for leave.";

                setNotification({
                    message: finalMessage,
                    type: "error",
                });
            } else {
                setNotification({
                    message: "Failed to apply for leave. Please try again.",
                    type: "error",
                });
            }
        } finally {
            setLoading(false);
        }
    };

    // Handle edit leave
    const handleEditLeave = async (updatedLeave, event) => {
        if (event) event.preventDefault();
        // console.log("Updated Leave Data:", updatedLeave);
        // console.log("Updated Leave ID:", updatedLeave.id);

        try {
            // console.log("Updated Leave Data:", updatedLeave);
            // console.log("Updated Leave ID:", updatedLeave.id);

            const response = await axios.put(
                `https://hrmsnew.prepstripe.com/api/leave-requests/${updatedLeave.id}`,
                updatedLeave,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            setRequests((prevLeaves) =>
                prevLeaves.map((leave) =>
                    leave.id === updatedLeave.id ? response.data : leave
                )
            );

            // setNotification("Leave updated successfully");
            setNotification({
                message: "Leave updated successfully",
                type: "success"
            });
            setIsEditModalOpen(false);
        } catch (err) {
            // console.error("Error updating leave:", error);
            // setNotification("Failed to update OD Leave");
            if (err.response) {
                // setNotification(err.response.data.error || "Failed to edit leave.");
                setNotification({
                    message: `${err.response.data.error || "Failed to edit leave."}`,
                    type: "error"
                });
            } else {
                // setNotification("Failed to edit leave. Please try again.");
                setNotification({
                    message: "Failed to edit leave. Please try again.",
                    type: "error"
                });
            }
        }
    };
    
    // Handle opening the edit modal
    const openEditModal = (leave) => {
        setSelectedLeave(leave);
        setTimeout(() => {
            setIsEditModalOpen(true);
        }, 100); // Ensures modal updates correctly
    };

    const handleDelete = async (id) => {
        // console.log(id, token)
        try {
          await axios.delete(`https://hrmsnew.prepstripe.com/api/leave-requests/${id}`, {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
          });
      
          // Remove the deleted request from the state
          setRequests((prevRequests) => prevRequests.filter((req) => req.id !== id));
        //   setNotification("Leave deleted successfully");
        setNotification({
            message: "Leave deleted successfully.",
            type: "success"
        });
        } catch (error) {
          console.error("Error deleting leave:", error);
        //   setNotification("Failed to delete Leave");
          setNotification({
            message: "Failed to delete Leave",
            type: "error"
        });
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
          setCurrentPage(newPage);
          fetchLeaveRequests(newPage);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        for (let i = 1; i <= pagination.totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              className={`px-4 py-2 rounded-md mx-1 ${
                currentPage === i ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
            >
              {i}
            </button>
          );
        }
        return pages;
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        const filtering = value !== '';
        setIsFiltering(filtering);
      
        if (!filtering) {
          // Search cleared, restore current page's data
          handlePageChange(currentPage); // fetchResponses will be called inside
        }
    };
      

    // Filtered Leaves (guard against non-array requests)
    const safeRequests = Array.isArray(requests) ? requests : [];
    const filteredLeaves = filter === "All"
        ? safeRequests
        : safeRequests.filter((leave) => (leave?.request?.status || "").toLowerCase() === filter.toLowerCase());

    // Further filter by search term
    const searchedLeaves = filteredLeaves.filter((leave) =>
        (leave?.leave_type || "").toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    const resetForm = () => {
        setFormData({
            // leave_period: "",
            from_date: "",
            to_date: "",
            start_day: "",
            start_half: "",
            last_day: "",
            last_half: "",
            leave_type: "",
            total_days: "",
            reason: "",
        });
    };

    function formatToInputDate(value) {
        if (!value) return "";
        const [day, month, year] = value.split("-");
        if (!day || !month || !year) return "";
        return `${year}-${month}-${day}`;
    }

    // Convert "2025-05-20" to "20-05-2025"
    function formatToDisplayDate(value) {
        if (!value) return "";
        const [year, month, day] = value.split("-");
        if (!day || !month || !year) return "";
        return `${day}-${month}-${year}`;
    }

    const hasTempFilters = Object.values(tempFilters).some((val) => val !== "");

    return (
        <div className="p-4 sm:p-6 bg-white dark:bg-gray-900 shadow-lg rounded-lg">
            
            {/* notification compo */}
            {notification && (
                <Notification message={notification.message} type={notification.type} onClose={() => setNotification(null)} />
            )}

            {/* Breadcrumb */}
            <nav className="flex flex-wrap mb-4" aria-label="Breadcrumb">
                <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                    <li>
                        <div className="flex items-center">
                            <Link
                            to={getRoleBasedRouteLocal("/admin/attendance_management")}
                            className="text-sm sm:text-md font-medium text-gray-700 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-500"
                            >
                            Attendance Management
                            </Link>
                        </div>
                    </li>
                    <li aria-current="page">
                        <div className="flex items-center">
                            <svg className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
                            </svg>
                            <span className="ms-1 text-sm sm:text-md font-medium text-gray-500 md:ms-2 dark:text-gray-400">Leave</span>
                        </div>
                    </li>
                </ol>
            </nav>

            <h2 className="text-lg sm:text-xl font-semibold mb-4 dark:text-white">Apply Leave</h2>

            <div className="flex flex-col sm:flex-row gap-2 md:justify-between sm:items-start mb-4">
                <div className="flex flex-col md:justify-between sm:flex-row sm:items-center gap-2">   
                    <button
                        onClick={() => {
                            if (!user.manager) {
                                setNotification({
                                    message: "Manager is not allocated.",
                                    type: "error",
                                });
                                return;
                            }
                            setIsApplyModalOpen(true);
                        }}
                        className="flex items-center justify-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md">
                        <FaPlus /> Apply Leave
                    </button>
                    {/* search field */}
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="w-full dark:bg-black dark:text-white dark:border-gray-700 sm:w-64 placeholder:text-xs md:placeholder:text-sm p-2 border border-gray-300 rounded-md"
                    />
                </div> 
                {/* filter button */}
                <div className="flex justify-between gap-2 w-full sm:w-auto">
                    <div className="relative">
                        <button 
                            onClick={toggleFilterMenu}
                            className="p-2 dark:bg-gray-800 dark:text-white dark:border-gray-700 border border-[#F4F7FF] rounded-md flex gap-1 items-center bg-[#F4F7FF] hover:bg-gray-200"
                            >
                            <svg className="dark:text-white" width="18" height="17" viewBox="0 0 13 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.98734 13.5608C7.85034 13.5608 7.71598 13.5252 7.59884 13.4581L5.09834 12.0415C4.817 11.8812 4.58412 11.6552 4.42215 11.3852C4.26017 11.1153 4.17457 10.8104 4.17359 10.5001V7.29493C4.17408 7.06871 4.0996 6.84803 3.96059 6.6638L0.469345 2.02988C0.387822 1.92291 0.339174 1.79674 0.328769 1.66531C0.318364 1.53387 0.346605 1.40228 0.410378 1.28504C0.474151 1.16781 0.570975 1.06949 0.690169 1.00093C0.809362 0.932381 0.94629 0.896259 1.08584 0.896552H11.8333C11.973 0.896002 12.1101 0.931967 12.2295 1.00047C12.3488 1.06896 12.4458 1.16732 12.5096 1.28465C12.5734 1.40198 12.6016 1.5337 12.5911 1.66523C12.5805 1.79677 12.5317 1.92297 12.4498 2.02988L8.95859 6.6638C8.81933 6.84794 8.74458 7.06863 8.74484 7.29493V12.844C8.74465 13.0338 8.66482 13.2158 8.52285 13.3502C8.38088 13.4845 8.18832 13.5603 7.98734 13.5608ZM1.08584 1.60843L4.57109 6.25297C4.80208 6.55645 4.92547 6.92118 4.92359 7.29493V10.4994C4.92387 10.6874 4.9756 10.8722 5.07376 11.0358C5.17192 11.1994 5.31319 11.3362 5.48384 11.433L7.98434 12.8497L7.99484 7.29422C7.99319 6.92039 8.11685 6.55566 8.34809 6.25226L11.8386 1.61834L1.08584 1.60843Z" fill="currentColor"/>
                            </svg>
                            <span className="ml-1">Filter</span>
                        </button>
                        
                        {showFilterMenu && (
                        <div className="absolute dark:bg-gray-900 dark:border-gray-700 z-10 mt-2 md:right-0 right-auto left-0 md:left-auto bg-white border border-gray-200 rounded-md shadow-lg p-4 w-64">
                            <div className="flex justify-between items-center mb-2">
                                <h3 className="font-medium dark:text-white">Filters</h3>
                                {hasTempFilters && (
                                    <button
                                        onClick={() => {
                                        setActiveFilters(tempFilters);
                                        setShowFilterMenu(false);
                                        }}
                                        className=" bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 text-sm"
                                    >
                                        Apply Filters
                                    </button>
                                )}
                            </div>
                            
                            <div className="space-y-3">
                            {filterableColumns.map((column) => (
                                <div key={column.field} className="space-y-1">
                                <label className="block text-sm dark:text-gray-400 font-medium text-gray-700">
                                    {column.label} 
                                </label>
                                {column.field === "status" ? (
                                    // Dropdown for status filter
                                    <select
                                        // value={activeFilters[column.field] || ""}
                                        value={tempFilters[column.field] || ""}
                                        // onChange={(e) => handleFilterChange(column.field, e.target.value)}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setTempFilters(prev => ({ ...prev, [column.field]: value }));
                                        }}
                                        className="w-full dark:bg-black dark:text-white dark:border-gray-700 p-2 text-sm border border-gray-300 rounded-md"
                                        >
                                        <option value="">All</option>
                                        <option value="approved">Approved</option>
                                        <option value="pending">Pending</option>
                                    </select>
                                ) : column.field === "from_date" || column.field === "to_date" ? (
                                    <input
                                        type="date"
                                        // value={activeFilters[column.field] || ""}
                                        value={tempFilters[column.field] || ""}
                                        // onChange={(e) =>
                                        //     handleFilterChange(column.field, e.target.value) // Store as yyyy-MM-dd
                                        // }
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setTempFilters(prev => ({ ...prev, [column.field]: value }));
                                        }}
                                        className="w-full dark:bg-gray-950 dark:border-gray-700 dark:text-white p-2 text-sm border border-gray-300 rounded-md"
                                    />
                                ) : (
                                    // Text input for other filters
                                    <input
                                        type="text"
                                        // value={activeFilters[column.field] || ""}
                                        value={tempFilters[column.field] || ""}
                                        // onChange={(e) => handleFilterChange(column.field, e.target.value)}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setTempFilters(prev => ({ ...prev, [column.field]: value }));
                                        }}
                                        placeholder={`Filter by ${column.label.toLowerCase()}`}
                                        className="w-full dark:bg-black dark:text-white dark:border-gray-700 p-2 text-sm border border-gray-300 rounded-md"
                                    />
                                )}
                                </div>
                            ))}
                            </div>
                            
                            {isFiltering && (
                            <div className="mt-3 pt-3 border-t border-gray-200">
                                <p className="text-sm text-gray-600">
                                Showing {filteredData.length} of {requests.length} results
                                </p>
                            </div>
                            )}
                        </div>
                        )}
                    </div>
                        
                    {isFiltering && (
                    <div className="flex flex-wrap gap-2 mt-2">
                        {Object.entries(activeFilters).map(([key, value]) => (
                        value && (
                            <div
                            key={key}
                            className="flex items-center gap-2 px-3 py-1.5 border border-blue-500 bg-blue-50 text-blue-600 rounded-full text-sm shadow-sm"
                            >
                            <span className="capitalize">{key.replace('_', ' ')}: {value}</span>
                            <button
                                onClick={() => clearFilterByKey(key)}
                                className="w-5 h-5 flex items-center justify-center rounded-full hover:bg-blue-100 focus:outline-none"
                                aria-label={`Clear ${key}`}
                            >
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                                >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                            </div>
                        )
                        ))}
                        <button
                        onClick={clearFilters}
                        className="ml-2 text-sm text-red-500 hover:underline"
                        >
                        Clear All
                        </button>
                    </div>
                    )}


                </div>

            </div>

            {/* Applied Leaves Table */}
            <div className="overflow-x-auto bg-white dark:bg-gray-900 shadow-md rounded-lg">
                <table className="min-w-full table-auto md:table-fixed text-sm">
                    <thead className="bg-gray-100 dark:bg-gray-800 dark:text-white">
                        <tr>
                            {/* <th className="border p-2">ID</th> */}
                            <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-gray-700 whitespace-nowrap">Leave Type</th>
                            <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-gray-700 whitespace-nowrap">From</th>
                            <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-gray-700 whitespace-nowrap">To</th>
                            <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-gray-700 whitespace-nowrap">Total Days</th>
                            <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-gray-700 whitespace-nowrap">Reason</th>
                            <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-gray-700 whitespace-nowrap">Status</th>
                            <th className="py-2 px-4 dark:text-white text-center text-xs md:text-sm text-gray-700 whitespace-nowrap">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    {leaveLoading ? (
                        <tr className="border-b hover:bg-gray-100 dark:hover:bg-gray-800">
                            <td colSpan={7} className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                                <div className="animate-spin h-6 w-6 border-2 border-blue-500 border-t-transparent rounded-full mx-auto mb-2 mt-2"></div>
                            </td>
                        </tr>
                    ) : 
                        filteredData.length === 0 ? (
                        <tr>
                            <td
                                colSpan={7}
                                className="text-center dark:text-white text-gray-500 p-2">
                                    No record found
                            </td>
                        </tr>
                    ) : (
                        filteredData.map((leave) => (
                            <tr key={leave.id} className="border-b dark:border-gray-700 dark:hover:bg-gray-950 dark:hover:text-white dark:text-white  hover:bg-gray-100">
                                {/* <td className="border p-2 text-center">{leave.id}</td> */}
                                <td className="py-2 px-4 dark:text-white  text-xs md:text-sm whitespace-nowrap">{leave.leave_type}</td>
                                <td className="py-2 px-4 dark:text-white  text-xs md:text-sm whitespace-nowrap">{leave.from_date}</td>
                                <td className="py-2 px-4 dark:text-white  text-xs md:text-sm whitespace-nowrap">{leave.to_date}</td>
                                <td className="py-2 px-4 dark:text-white  text-xs md:text-sm whitespace-nowrap">{leave.total_days}</td>
                                <td title={leave.reason} className=" p-2 whitespace-nowrap truncate max-w-xs">
                                    {leave.reason}
                                </td>
                                <td className={`py-2 px-4 text-xs md:text-sm whitespace-nowrap capitalize ${leave.request.status === "approved" ? "text-green-600" : leave.request.status === "rejected" ? "text-red-600" : "text-yellow-600"}`}>
                                    {leave.request.status}
                                </td>

                                 {/* other cells */}
                                <td className="p-2 flex justify-center gap-2 relative">
                                    <button
                                    ref={openRow === leave.id ? buttonRef : null}
                                    onClick={() => setOpenRow(openRow === leave.id ? null : leave.id)}
                                    className="text-blue-500"
                                    >
                                        <MoreVertical className="w-4 h-4 text-gray-600 dark:text-gray-400" />   
                                    </button>

                                    {openRow === leave.id && (
                                    <DropdownMenu
                                        buttonRef={buttonRef}
                                        onClose={() => setOpenRow(null)}
                                    >
                                        <button
                                        className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                                        onClick={() => {
                                            setSelectedLeave(leave);
                                            setDrawerOpen(true);
                                            setOpenRow(null);
                                        }}
                                        >
                                        View
                                        </button>
                                        {leave.request.status === "pending" && (
                                        <button
                                            className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                                            onClick={() => {
                                            openEditModal(leave);
                                            setOpenRow(null);
                                            }}
                                        >
                                            Edit
                                        </button>
                                        )}

                                        <DeleteButton 
                                            style={"block w-full text-red-600 text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"} 
                                            onDelete={() => handleDelete(leave.id)} 
                                        /> 
                                    </DropdownMenu>
                                    )}
                                </td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
        
            {/* pagination */}
            {!isFiltering && filteredData?.length > 0 && (
                <ReactPaginate
                    breakLabel="..."
                    onPageChange={(event) => handlePageChange(event.selected + 1)}
                    forcePage={currentPage - 1} // very important!
                    pageRangeDisplayed={5}
                    pageCount={pagination.totalPages}
                    renderOnZeroPageCount={null}
                    nextLabel="Next >"
                    previousLabel="< Prev"
                    previousClassName='dark:text-white px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 dark:border-gray-600 dark:hover:bg-gray-800'
                    nextClassName="dark:text-white px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 dark:border-gray-600 dark:hover:bg-gray-800"
                    containerClassName="flex items-center justify-center mt-4"
                    pageClassName="mx-1 px-3 py-1 border rounded dark:text-white"
                    activeClassName="bg-blue-500 text-white dark:bg-black dark:text-white dark:border-gray-700"
                />
            )}
            
            {/* Apply Leave modal */}
            {isApplyModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end md:items-center z-50 backdrop-blur-sm" onClick={() => { setIsApplyModalOpen(false); resetForm(); }}>
                    <div className="bg-white dark:bg-gray-900 rounded-t-2xl md:rounded-lg shadow-xl w-full max-w-md mx-auto relative transition-transform duration-300 transform md:animate-none animate-slideUp" onClick={(e) => e.stopPropagation()}>
                        {/* <h2 className="text-xl font-semibold mb-4">Apply for Leave</h2> */}
                        
                        {error && <p className="text-red-500">{error}</p>}

                        <form onSubmit={handleApplyLeave} className="bg-white dark:bg-gray-900 sm:rounded-lg rounded-t-2xl">

                            {/* modal title */}
                            {/* <div className="px-4 py-3 flex items-center justify-between border-b dark:border-gray-700 border-gray-300">
                                <h2 className="md:text-xl dark:text-white text-md font-semibold">
                                    Apply For Leave
                                </h2>
                                <button 
                                    type="button" 
                                    onClick={() => {
                                        setIsApplyModalOpen(false);
                                        resetForm();
                                    }} 
                                    className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-300 dark:focus:ring-red-600"
                                    aria-label="Close modal"
                                >
                                    <svg 
                                        className="w-5 h-5" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        viewBox="0 0 24 24" 
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path 
                                            strokeLinecap="round" 
                                            strokeLinejoin="round" 
                                            strokeWidth={2} 
                                            d="M6 18L18 6M6 6l12 12" 
                                        />
                                    </svg>
                                </button>
                            </div> */}

                            <div className="relative">
                                <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-gray-800 dark:to-gray-850"></div>
                                <div className="relative flex items-center justify-between p-4 border-b border-gray-200/50 dark:border-gray-700/50">
                                    <div className="flex items-center space-x-3">
                                        <div className="w-1 h-6 bg-gradient-to-b from-blue-500 to-purple-600 rounded-full"></div>
                                        <h2 className="text-xl font-semibold text-gray-900 dark:text-white tracking-tight">
                                            Apply For Leave
                                        </h2>
                                    </div>
                                    
                                    {/* Enhanced close button */}
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setIsApplyModalOpen(false);
                                            resetForm();
                                        }} 
                                        className="group relative p-2 rounded-xl bg-gray-100/80 hover:bg-red-50 dark:bg-gray-800/80 dark:hover:bg-red-900/20 transition-all duration-200 hover:scale-105 active:scale-95"
                                        aria-label="Close modal">
                                        <X 
                                        size={20} 
                                        className="text-gray-600 group-hover:text-red-500 dark:text-gray-400 dark:group-hover:text-red-400 transition-colors duration-200" 
                                        />
                                        <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-red-500/0 to-red-600/0 group-hover:from-red-500/10 group-hover:to-red-600/10 transition-all duration-200"></div>
                                    </button>
                                </div>
                            </div>

                            {/* modal body */}
                            <div className="max-h-[80vh] overflow-y-auto flex flex-col gap-y-2 rounded-lg bg-white dark:bg-gray-900 p-4">

                                {/* from, to date */}
                                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                                    <div>
                                        <label htmlFor="from_date" className="block text-sm font-medium dark:text-white">
                                            From Date <span className="text-red-500 ml-1">*</span>
                                        </label>
                                        <input
                                            id="from_date"
                                            type="date"
                                            name="from_date"
                                            value={formData.from_date}
                                            onChange={handleChange}
                                            min={new Date().toISOString().split("T")[0]} // today
                                            max={new Date(new Date().getFullYear(), 11, 31).toISOString().split("T")[0]} // end of year
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="to_date" className="block text-sm font-medium dark:text-white">
                                            To Date <span className="text-red-500 ml-1">*</span>
                                        </label>
                                        <input
                                            id="to_date"
                                            type="date"
                                            name="to_date"
                                            value={formData.to_date}
                                            onChange={handleChange}
                                            min={formData.from_date || new Date().toISOString().split("T")[0]} // minimum is from_date
                                            max={new Date(new Date().getFullYear(), 11, 31).toISOString().split("T")[0]} // end of year
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2"
                                            required
                                        />
                                    </div>
                                </div>

                                {/* start day, last day, start_half, last_half*/}
                                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                                    {/* Start Day Selection */}
                                    <div>
                                        <label className="block text-sm font-medium dark:text-white">Start Day <span className="text-red-500 ml-1">*</span></label>
                                        <select 
                                            value={formData.start_day} 
                                            name="start_day" 
                                            onChange={handleChange}
                                            required 
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm">
                                            <option value="">Select an option</option>
                                            <option value="Full">Full</option>
                                            <option value="Half">Half</option>
                                        </select>

                                        {/* Half-Day Selection for Start Day */}
                                        {formData.start_day === "Half" && (
                                            <div className="mt-2">
                                                <label className="block text-sm font-medium dark:text-white">For Half</label>
                                                <select 
                                                    value={formData.start_half} 
                                                    name="start_half" 
                                                    onChange={handleChange}
                                                    required 
                                                    className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm">
                                                    <option value="">Select an option</option>
                                                    <option value="First">First Half</option>
                                                    <option value="Second">Second Half</option>
                                                </select>
                                            </div>
                                        )}
                                    </div>

                                    {/* Last Day Selection */}
                                    <div>
                                        <label className="block text-sm font-medium dark:text-white">Last Day</label>
                                        <select 
                                            value={formData.from_date === formData.to_date ? "" : formData.last_day} 
                                            name="last_day" 
                                            onChange={handleChange} 
                                            disabled={formData.from_date === formData.to_date} 
                                            required
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm">
                                            <option value="">Select an option</option>
                                            <option value="Full">Full</option>
                                            <option value="Half">Half</option>
                                        </select>

                                        {/* Half-Day Selection for Last Day */}
                                        {formData.last_day === "Half" && (
                                            <div className="mt-2">
                                                <label className="block text-sm font-medium dark:text-white">For Half</label>
                                                <select 
                                                    value={formData.last_half} 
                                                    name="last_half" 
                                                    onChange={handleChange} 
                                                    required
                                                    className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm">
                                                    <option value="">Select an option</option>
                                                    <option value="First">First Half</option>
                                                    <option value="Second">Second Half</option>
                                                </select>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                
                                {/* leave type */}
                                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                                    <div>
                                        <label className="block font-medium dark:text-white">Leave Type <span className="text-red-500 ml-1">*</span></label>
                                        <select
                                            name="leave_type"
                                            value={formData.leave_type}
                                            // value={formData.leave_type || (leaveTypes.length > 0 ? leaveTypes[0].name : "")}
                                            onChange={(e) => setFormData((prev) => ({ ...prev, leave_type: e.target.value }))}
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 p-2 border rounded text-sm"
                                            required
                                        >   
                                        
                                        <option value="">Select an option</option>
                                            {leaveTypes.map((leave) => (
                                                <option key={leave.id} value={leave.name}>
                                                    {leave.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium  dark:text-white">Total Days </label>
                                        <p className="p-2 dark:bg-black dark:border-gray-700 border rounded dark:text-white">{total_days} days</p>
                                        <input type="number" hidden value={formData.total_days} name={total_days} onChange={handleChange} className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2" />
                                    </div>
                                </div>

                                {/* reason */}
                                <div>
                                    <label className="block font-medium dark:text-white">Reason <span className="text-red-500 ml-1">*</span></label> 
                                    <textarea
                                        name="reason"
                                        value={formData.reason}
                                        // onChange={(e) => {
                                        //     const input = e.target.value;
                                        //     const filteredInput = input.replace(/[^a-zA-Z\s.,!?']/g, '');
                                        //     setFormData({ ...formData, reason: filteredInput });
                                        // }}
                                        onChange={(e) => {
                                            const input = e.target.value;
                                            const filteredInput = input.replace(/[^a-zA-Z\s.,!?']/g, '');
                                            setFormData({ ...formData, reason: filteredInput });
                                        }}
                                        onBlur={() => {
                                            // Trim and validate on blur
                                            const trimmed = formData.reason.trim();
                                            if (trimmed === '') {
                                                alert('Reason cannot be empty or just spaces');
                                            }
                                        }}
                                        maxLength={50}
                                        className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 p-2 border rounded"
                                        required
                                    />
                                    <p className="text-sm text-gray-500 mt-1">{formData.reason.length}/50 characters</p>
                                </div>

                            </div>

                            <hr className="text-gray-300 dark:border-gray-700"/>
                            
                            {/* apply & cancel buttons */}
                            <div className="px-4 py-5 flex justify-between items-center">
                                <button
                                    type="button"
                                    className="bg-gray-500 dark:bg-black hover:bg-gray-600 text-white px-10 py-2 rounded-md"
                                    onClick={() => {
                                        setIsApplyModalOpen(false);
                                        resetForm();
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="bg-blue-500 hover:bg-blue-600 text-white px-10 py-2 rounded-md"
                                    disabled={loading}
                                >
                                    {loading ? "Applying..." : "Apply Leave"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* edit modal */}
            {isEditModalOpen && selectedLeave && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end md:items-center z-50 backdrop-blur-sm" onClick={() => { setIsEditModalOpen(false); resetForm(); }}>
                    <div className="bg-white dark:bg-gray-900 rounded-t-2xl md:rounded-lg shadow-xl w-full max-w-md mx-auto relative transition-transform duration-300 transform md:animate-none animate-slideUp" onClick={(e) => e.stopPropagation()}>
                        {/* <h2 className="text-xl font-bold mb-4">Edit Leave Request</h2> */}
                        
                        <form onSubmit={(e) => handleEditLeave(selectedLeave, e)} className="bg-white dark:bg-gray-900 sm:rounded-lg rounded-t-2xl">

                            {/* modal title */}
                            {/* <div className="px-4 py-3 flex items-center justify-between border-b dark:border-gray-700 border-gray-300">
                                <h2 className="md:text-xl dark:text-white text-md font-semibold">
                                    Edit Leave
                                </h2>
                                <button 
                                    type="button" 
                                    onClick={() => {
                                        setIsEditModalOpen(false);
                                        resetForm();
                                    }} 
                                    className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-300 dark:focus:ring-red-600"
                                    aria-label="Close modal"
                                >
                                    <svg 
                                        className="w-5 h-5" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        viewBox="0 0 24 24" 
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path 
                                            strokeLinecap="round" 
                                            strokeLinejoin="round" 
                                            strokeWidth={2} 
                                            d="M6 18L18 6M6 6l12 12" 
                                        />
                                    </svg>
                                </button>
                            </div> */}

                            <div className="relative">
                                <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-gray-800 dark:to-gray-850"></div>
                                <div className="relative flex items-center justify-between p-4 border-b border-gray-200/50 dark:border-gray-700/50">
                                    <div className="flex items-center space-x-3">
                                        <div className="w-1 h-6 bg-gradient-to-b from-blue-500 to-purple-600 rounded-full"></div>
                                        <h2 className="text-xl font-semibold text-gray-900 dark:text-white tracking-tight">
                                            Edit Leave
                                        </h2>
                                    </div>
                                    
                                    {/* Enhanced close button */}
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setIsEditModalOpen(false);
                                            resetForm();
                                        }} 
                                        className="group relative p-2 rounded-xl bg-gray-100/80 hover:bg-red-50 dark:bg-gray-800/80 dark:hover:bg-red-900/20 transition-all duration-200 hover:scale-105 active:scale-95"
                                        aria-label="Close modal">
                                        <X 
                                        size={20} 
                                        className="text-gray-600 group-hover:text-red-500 dark:text-gray-400 dark:group-hover:text-red-400 transition-colors duration-200" 
                                        />
                                        <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-red-500/0 to-red-600/0 group-hover:from-red-500/10 group-hover:to-red-600/10 transition-all duration-200"></div>
                                    </button>
                                </div>
                            </div>

                            {/* modal body */}
                            <div className="max-h-[80vh] overflow-y-auto flex flex-col gap-y-2 rounded-lg dark:bg-gray-900 bg-white p-4">

                                {/* period */}
                                {/* <div className="md:text-md text-sm">
                                    <div>
                                        <label className="block dark:text-white md:text-md text-sm">Period <span className="text-red-500 ml-1">*</span></label>
                                        <select 
                                            value={selectedLeave.leave_period} 
                                            name="leave_period" 
                                            onChange={handleChangeEdit} 
                                            required
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm">
                                            <option value="" className="text-sm">Select an option</option>  
                                            <option value="2024-2025">2024-2025</option>
                                        </select>
                                    </div>
                                </div> */}

                                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                                    <div>
                                        <label htmlFor="from_date" className="block dark:text-white text-sm font-medium">
                                            From Date <span className="text-red-500 ml-1">*</span>
                                        </label>
                                        <input
                                            id="from_date"
                                            type="date"
                                            // name="from_date"
                                            value={selectedLeave.from_date}
                                            onChange={(e) =>
                                                setSelectedLeave({ ...selectedLeave, from_date: e.target.value })
                                            }
                                            min={new Date().toISOString().split("T")[0]}
                                            max={new Date(new Date().getFullYear(), 11, 31).toISOString().split("T")[0]}
                                            required
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2"
                                        />
                                        </div>
                                    <div>
                                        <label htmlFor="to_date" className="block dark:text-white text-sm font-medium">
                                            To Date <span className="text-red-500 ml-1">*</span>
                                        </label>
                                        <input
                                            id="to_date"
                                            type="date"
                                            // name="to_date"
                                            value={selectedLeave.to_date}
                                            onChange={(e) =>
                                                setSelectedLeave({ ...selectedLeave, to_date: e.target.value })
                                            }
                                            min={formData.from_date || new Date().toISOString().split("T")[0]} // minimum is from_date
                                            max={new Date(new Date().getFullYear(), 11, 31).toISOString().split("T")[0]} // end of year
                                            required
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2"
                                        />
                                    </div>
                                </div>

                                {/* start start half, last last half   */}
                                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                                    <div>
                                        <label className="block text-sm font-medium dark:text-white">Start Day <span className="text-red-500 ml-1">*</span></label>
                                        <select 
                                            value={selectedLeave.start_day} 
                                            name="start_day" 
                                            onChange={handleChangeEdit} 
                                            required
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm">
                                            <option value="">Select an option</option>
                                            <option value="Full">Full</option>
                                            <option value="Half">Half</option>
                                        </select>

                                        {selectedLeave.start_day === "Half" ? (
                                            <div className="mt-2">
                                                <label className="block text-sm font-medium dark:text-white">For Half <span className="text-red-500 ml-1">*</span></label>
                                                <select 
                                                    value={selectedLeave.start_half} 
                                                    name="start_half" 
                                                    onChange={handleChangeEdit} 
                                                    required
                                                    className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm">
                                                    <option value="">Select an option</option>
                                                    <option value="First">First Half</option>
                                                    <option value="Second">Second Half</option>
                                                </select>
                                            </div>
                                        ) : null}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium dark:text-white">Last Day</label>
                                        <select 
                                            value={selectedLeave.from_date === selectedLeave.to_date ? ("") : (selectedLeave.last_day)} 
                                            name="last_day" 
                                            onChange={handleChangeEdit}
                                            disabled={selectedLeave.from_date === selectedLeave.to_date} 
                                            required
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm">
                                            <option value="">Select an option</option>
                                            <option value="Full">Full</option>
                                            <option value="Half">Half</option>
                                        </select>

                                        {selectedLeave.last_day === "Half" ? (
                                            <div className="mt-2">
                                            <label className="block text-sm font-medium dark:text-white">For Half <span className="text-red-500 ml-1">*</span></label>
                                            <select 
                                                value={selectedLeave.last_half} 
                                                name="last_half" 
                                                onChange={handleChangeEdit} 
                                                required
                                                className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm">
                                                <option value="">Select an option</option>
                                                <option value="First">First Half</option>
                                                <option value="Second">Second Half</option>
                                            </select>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>

                                {/* leave type */}
                                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                                    <div>
                                        <label className="block font-medium dark:text-white">Leave Type <span className="text-red-500 ml-1">*</span></label>
                                        <select
                                            name="leave_type"
                                            value={selectedLeave.leave_type}
                                            onChange={handleChangeEdit}
                                            className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 p-2 border rounded text-sm"
                                            required>   
                                            <option value="PL">PL</option>
                                            <option value="LWP">LWP</option>
                                            <option value="CO+">CO-</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block dark:text-white text-sm font-medium">Total Days</label>
                                        <p className="p-2 border dark:bg-black dark:text-white dark:border-gray-700 rounded">{selectedLeave.total_days} days</p>
                                        <input type="number" hidden value={selectedLeave.total_days} name="total_days" onChange={handleChange} className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2" />
                                    </div>
                                </div>
                                
                                {/* reason */}
                                <div className="md:text-md text-sm">
                                    <label className="block dark:text-white font-medium">Reason <span className="text-red-500 ml-1">*</span></label>
                                    <textarea
                                        name="reason"
                                        rows={4}
                                        className="p-2 dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 w-full rounded"
                                        value={selectedLeave.reason}
                                        onChange={(e) => {
                                            const input = e.target.value;
                                            const filteredInput = input.replace(/[^a-zA-Z\s.,!?']/g, '');
                                            setSelectedLeave({ ...selectedLeave, reason: filteredInput });
                                        }}
                                        maxLength={50}
                                        required
                                    />
                                    <p className="text-sm text-gray-500 mt-1">{selectedLeave.reason.length}/50 characters</p>
                                </div>
                            </div>

                            <hr className="text-gray-300 dark:border-gray-700"/>
                            
                            {/* submit and cancel button */}
                            <div className="px-4 py-5 flex justify-between items-center">
                                <button
                                    type="button"
                                    className="bg-gray-500 dark:bg-black  hover:bg-gray-600 text-white px-10 py-2 rounded-md"
                                    onClick={() => {
                                        setIsEditModalOpen(false);
                                        resetForm();
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="bg-blue-500 hover:bg-blue-600 text-white px-10 py-2 rounded-md"
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            
            {/* drawer to view details */}
            <Drawer
                isOpen={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                ChilDiv=""
                ChildParent=""
                height_width="w-full max-w-3xl px-6 py-6 md:rounded-3xl"
                showClose={false}
                >
                {selectedLeave && (
                    <div className="space-y-6 p-4">
                    {/* Header */}
                    <div className="flex items-center justify-between border-b dark:border-gray-700 pb-4">
                        <h3 className="text-xl md:text-2xl dark:text-white font-semibold text-gray-800">
                        📝 Leave Request Details
                        </h3>
                        <div className="flex items-center gap-3">
                        <span
                            className={`text-sm font-semibold px-3 py-1 capitalize rounded-full
                            ${selectedLeave.request.status === 'approved'
                                ? 'bg-green-100 text-green-600'
                                : selectedLeave.request.status === 'rejected'
                                ? 'bg-red-100 text-red-600'
                                : 'bg-yellow-100 text-yellow-600'}`}
                        >
                            {selectedLeave.request.status || 'pending'}
                        </span>

                        <button
                            onClick={() => setDrawerOpen(false)}
                            className="text-gray-500 hover:text-red-500 transition"
                        >
                            <X className="w-5 h-5" />
                        </button>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Left Column */}
                        <div className="space-y-4 text-sm text-gray-700">
                        <Detail label="Leave Type" value={selectedLeave.leave_type} />
                        {/* <Detail label="Leave Period" value={selectedLeave.leave_period} /> */}
                        <Detail label="From Date" value={selectedLeave.from_date} />
                        <Detail label="To Date" value={selectedLeave.to_date} />
                        <Detail label="Start Day" value={selectedLeave.start_day} />
                        {selectedLeave.start_half && (
                            <Detail label="Start Half" value={selectedLeave.start_half} />
                        )}
                        </div>

                        {/* Right Column */}
                        <div className="space-y-4 text-sm text-gray-700">
                        <Detail label="Last Day" value={selectedLeave.last_day} />
                        {selectedLeave.last_half && (
                            <Detail label="Last Half" value={selectedLeave.last_half} />
                        )}
                        <Detail label="Total Days" value={selectedLeave.total_days} />
                        <Detail label="Reason" value={selectedLeave.reason} />
                        {selectedLeave.request.approver_comments && selectedLeave.request.action_date && (
                            <>
                                <hr className="my-4" />
                                <Detail label="Approver's Comment" value={selectedLeave.request.approver_comments} />
                                <Detail label={`Request ${selectedLeave.request.status} On`} value={selectedLeave.request.action_date} />
                            </>
                        )}
                        </div>
                    </div>
                    </div>
                )}
            </Drawer>
        </div>
    );
};

const Detail = ({ label, value }) => (
  <div className="flex flex-col">
    <span className="text-gray-500 dark:text-white">{label}</span>
    <span className="font-medium text-gray-800 dark:text-gray-500">{value}</span>
  </div>
);

export default LeavePage;
